// extracted by mini-css-extract-plugin
module.exports = {"container":"UspBar_container___U4Fk","blocks":"UspBar_blocks__nGhIX"};